import type { SVGProps } from "react";
export interface BowlingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BowlingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BowlingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 15a5.876 5.876 0 0 0-8.392-5.31 1.127 1.127 0 0 1-.966-2.033 8.126 8.126 0 1 1 1.214 15.146l-.306-.095-.107-.042a1.125 1.125 0 0 1 .709-2.122l.111.03.446.13c.452.111.927.17 1.416.17a5.875 5.875 0 0 0 5.875-5.873Zm-4-.5a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.141a1.374 1.374 0 0 1 1.367-1.233l.14.007c.694.07 1.235.655 1.235 1.367m3-1a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141a1.374 1.374 0 0 1 1.367-1.235l.14.007c.694.07 1.235.656 1.235 1.369Zm-2.5-2a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.141A1.375 1.375 0 0 1 16 10.126l.141.007c.693.07 1.233.655 1.234 1.367m-10-7a1.375 1.375 0 1 0-2.75 0c0 .641.107 1.298.234 2.064.123.734.266 1.578.266 2.436 0 .607-.198 1.182-.403 1.662-.205.477-.485 1.005-.715 1.466-.496.991-.882 1.91-.882 2.873 0 1.134.232 2.774.639 4.108.204.672.432 1.196.652 1.528.09.136.155.204.191.238h2.787c.036-.034.102-.102.191-.238.22-.332.447-.856.65-1.528.407-1.335.64-2.974.64-4.109 0-.963-.385-1.88-.88-2.872-.231-.46-.512-.988-.717-1.466-.206-.48-.403-1.056-.403-1.662 0-.858.143-1.702.265-2.436.128-.766.234-1.423.235-2.064m2.25 0c0 .86-.143 1.702-.266 2.435-.127.767-.234 1.425-.234 2.065 0 .144.052.38.221.775.17.397.391.807.66 1.347.505 1.008 1.118 2.342 1.118 3.879 0 1.364-.266 3.225-.735 4.765-.233.765-.537 1.522-.927 2.112-.354.535-.991 1.246-1.962 1.247h-3c-.97 0-1.608-.712-1.962-1.247-.39-.59-.693-1.347-.926-2.112-.469-1.54-.737-3.4-.737-4.765 0-1.537.615-2.87 1.12-3.88.269-.539.488-.949.658-1.346.17-.394.221-.63.222-.775 0-.64-.107-1.298-.235-2.065-.122-.733-.265-1.576-.265-2.435a3.626 3.626 0 0 1 7.25 0"
      />
    </svg>
  );
}
